import { render, staticRenderFns } from "./PublicityNotice.vue?vue&type=template&id=be734afc&scoped=true"
import script from "./PublicityNotice.vue?vue&type=script&lang=js"
export * from "./PublicityNotice.vue?vue&type=script&lang=js"
import style0 from "./PublicityNotice.vue?vue&type=style&index=0&id=be734afc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be734afc",
  null
  
)

export default component.exports